'use strict';

const Mn = require('backbone.marionette');
const ActionRepository = require('process/domain/repository/action/index');
const AppTabView = require('balus/ui/view/body/project/app-tab');
const CoverTemplate = require('balus/ui/template/body/project/cover/index.hbs');
const StateTemplate = require('balus/ui/template/body/project/cover/state.hbs');

const StateView = Mn.View.extend({
    template: StateTemplate,
    tagName: 'span',
    templateContext: function() {
        return {
            state: this.model.getCurrentState().toJSON()
        }
    }
});

module.exports = Mn.View.extend({
    template: CoverTemplate,
    modelEvents: {
        'change': 'render'
    },
    regions: {
        'state': '.state-wrapper',
        'appTab': '.app-tab-wrapper'
    },

    templateContext: function() {
        return {
            path: this.model.path()
        };
    },

    onRender: function() {
        const actionID = this.model.getActionID();
        ActionRepository.find(this.model).get(actionID)
            .then(action => {
                this.listenTo(action, 'change', this.render);
                this.showChildView('state', new StateView({
                    model: action
                }));
            });

        this.showChildView('appTab', new AppTabView({
            model: this.model,
            context: this.getOption('context'),
            project: this.getOption('project'),
            process: this.getOption('process'),
            diagram: this.getOption('diagram'),
            dataContent: this.getOption('dataContent'),
            hideNavToggle: this.getOption('hideNavToggle')
        }));
    },

    openNav: function() {
        this.getChildView('appTab').openNav();
    },

    closeNav: function() {
        this.getChildView('appTab').closeNav();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/project/cover.js